import { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ContactContext } from "../context/ContactContext";
import ContactCard from '../components/ContactCard';
import CustomForm from '../components/CustomForm';
import SocialIcons from '../components/SocialIcons';
import '../assets/scss/pages/contact.scss';

const Contact = () =>  {
    const contact = useContext(ContactContext);

    return (
        <Container id="contact" className="pt-2 pb-5">
            <h2 className="d-flex align-items-center justify-content-center rounded-5 text-primary"><b>CONTACT</b> US</h2>
            <Row as="section" className="d-flex py-5 border-bottom justify-content-between" lg={2}>
                {/* Connect and Contact */}
                <Col className="my-3" lg={4}>
                    <Col className="py-md-4 pb-4">
                        <h6 className="fw-semibold pb-2">CONNECT WITH US</h6>
                        <SocialIcons links={ contact && contact?.social_links } bg={ true } />
                    </Col>
                    <ContactCard /> {/* Contact prop not passed here since contact is gotten from ContactContext in ContactCard */}
                </Col>

                {/* Form */}
                <Col className="my-3" lg={7}>
                    <CustomForm type="contact" />
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;
